<template>
  <div class="multi-npc-container">
    <b-tabs content-class="mt-0" fill>
      <b-tab
        v-for="ch in multiCh"
        :key="ch"
        :title="ch"
      >
        <iframe
          :src="iframeSrc(ch)"
          class="npc-iframe"
          allowfullscreen
        ></iframe>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
export default {
  name: "MultiNPC",
  props: {
    multiCh: {
      type: Array,
      required: true,
    },
  },
  methods: {
    iframeSrc(ch) {
      // 以同一頁面的 base URL 搭配 hash 路由，同源共享 localStorage session
      const base = window.location.pathname;
      return `${base}#/chat?ch=${encodeURIComponent(ch)}&demoMode=true`;
    },
  },
};
</script>

<style scoped>
.multi-npc-container {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.multi-npc-container > .tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.npc-iframe {
  width: 100%;
  height: calc(100vh - 50px);
  border: none;
  display: block;
}
</style>
